// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__89os0","shown":"Loader_shown__mfUU0","loader":"Loader_loader__oPvmc","spinner":"Loader_spinner__JN32S"};